import React from 'react'
import PropTypes from 'prop-types'
import FooterSubNav from './FooterSubnav'
import FooterHeader from './FooterHeader'

function FooterNav({ linkGroups }) {
  return linkGroups.map(({ title, links }) => (
    <li className="footer__item" key={title}>
      <FooterHeader title={title} />
      <div className="drop-down">
        <ul className="drop-down__list">
          {links.map(link => (
            <FooterSubNav link={link} key={link.title} />
          ))}
        </ul>
      </div>
    </li>
  ))
}

FooterNav.propTypes = {
  linkGroups: PropTypes.array.isRequired
}

export default FooterNav
